(() => {
  const instances = new Map();
  function init(scope = document) {
    scope.querySelectorAll('.dt').forEach(root => {
      if (instances.has(root)) return;
      const controller = new AbortController(), { signal } = controller;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const pageHeader=document.querySelector('.shopify-section-header');
      function setScrollOffset(){
        const height=pageHeader?.getBoundingClientRect().height||0;
        root.style.setProperty('--dtj-scroll-offset',Math.ceil(height+24)+'px');
      }
      setScrollOffset();
      let headerObserver;
      if(pageHeader&&'ResizeObserver' in window){headerObserver=new ResizeObserver(setScrollOffset);headerObserver.observe(pageHeader);}
      else window.addEventListener('resize',setScrollOffset,{signal});

      // Discover the actual sections even when their data hooks came from an older export.
      const chapters = [['letter','.dtj-letter'],['product','.dtj-commerce']].map(([name,selector]) => {
        const section=root.querySelector(selector);
        if(section)section.dataset.dtjChapter=name;
        return section;
      }).filter(Boolean);
      const originalVisibility = new Map();
      function setVisible(element, visible) {
        if (!element) return;
        if (!originalVisibility.has(element)) originalVisibility.set(element, {
          hidden:element.hidden,inert:element.inert,display:element.style.getPropertyValue('display'),priority:element.style.getPropertyPriority('display')
        });
        element.hidden=!visible;element.inert=!visible;
        // Enforce the scene boundary even if a theme rule overrides the hidden attribute.
        if(visible)element.style.removeProperty('display');
        else element.style.setProperty('display','none','important');
      }
      const experience = root.querySelector('.dtj-experience');
      const chapterNav = root.querySelector('.dtj-nav');
      const staged = chapters.length > 0;
      if (staged) root.classList.add('dtj-staged');
      function chapterFor(target) {
        if (target === root) return 'letter';
        return target?.closest('[data-dtj-chapter]')?.dataset.dtjChapter || 'product';
      }
      function showChapter(name, { target = null, focus = false, scroll = false, push = false, animate = false } = {}) {
        if (!staged) return;
        const section = chapters.find(chapter => chapter.dataset.dtjChapter === name);
        if (!section) return;
        chapters.forEach(chapter => setVisible(chapter, chapter === section));
        root.dataset.dtChapter = name;
        setVisible(experience, name !== 'product');
        setVisible(chapterNav, name === 'product');
        document.body.classList.toggle('dt-reading-active', name !== 'product');
        if (name !== 'product') { const bar = root.querySelector('[data-dtj-mobile-purchase]'); if (bar) bar.hidden = true; }
        setScrollOffset();
        if (push) history.pushState(null, '', '#' + (target || section).id);
        if (scroll) (target || section).scrollIntoView({ behavior: 'instant', block: 'start' });
        if (focus) {
          const focusTarget = target && section.contains(target) ? target : section;
          const heading = focusTarget.matches('h1,h2,[data-dtj-chapter-focus]') ? focusTarget : focusTarget.querySelector('h1,h2,[data-dtj-chapter-focus]') || focusTarget;
          heading.setAttribute('tabindex', '-1'); heading.focus({ preventScroll: true });
        }
        if (animate && !reduced.matches) {
          arrivalAnimation?.cancel();
          arrivalAnimation = section.animate([{opacity:0,transform:'translateY(8px)'},{opacity:1,transform:'none'}],{duration:450,easing:'ease-out'});
        }
      }

      const intro = root.querySelector('.dt-spiral-intro');
      const welcome = intro?.querySelector('.dt-welcome');
      const choice = intro?.querySelector('.dt-card-scene');
      const deck = intro?.querySelector('.dt-deck');
      const reflection = intro?.querySelector('.dt-reflection');
      const readingDelay=Math.min(30,Math.max(6,Number(root.dataset.dtReadingSeconds)||9))*1000;
      const cardTransition=Math.min(1200,Math.max(200,Number(root.dataset.dtCardTransition)||450));
      const thoughts = [...(intro?.querySelectorAll('[data-dt-thought]') || [])];
      const reflectionTimers = new Set(), reflectionAnimations = new Set();
      let reflectionVersion = 0;
      const enter = intro?.querySelector('.dt-intro-enter');
      const action = intro?.querySelector('.dt-choice-action');
      const cards = [...(intro?.querySelectorAll('[data-dt-card]') || [])];
      const cardNames = cards.map(card => card.getAttribute('aria-label'));
      const rotor = root.querySelector('.dt-oracle-rotor');
      const line = rotor?.querySelector('.dt-oracle-line');
      const replay = root.querySelector('[data-dt-replay]');
      const toggle = root.querySelector('[data-dt-motion]');
      const introToggle = intro?.querySelector('[data-dt-intro-motion]');
      const locked = new Map();
      let enabled = !reduced.matches, spin, drawing, drawVersion = 0, ramp = 0, readyTimer = 0, closing = false, exitAnimation, arrivalAnimation;
      let selected = -1;
      function labels() {
        root.classList.toggle('is-paused', !enabled);
        [toggle, introToggle].filter(Boolean).forEach(button => {
          button.textContent = enabled ? 'Pristabdyti animaciją' : 'Įjungti animaciją';
          button.setAttribute('aria-pressed', String(enabled));
        });
      }
      function setLocked(active) {
        if (active) {
          [...root.children].forEach(child => {
            if (child === intro || child.classList.contains('dt-oracle-spiral')) return;
            if (!locked.has(child)) locked.set(child, child.inert);
            child.inert = true;
          });
        } else {
          locked.forEach((value, child) => child.inert = value);
          locked.clear();
        }
        document.body.classList.toggle('dt-intro-active', active);
      }
      function startSpin(accelerate = false) {
        cancelAnimationFrame(ramp);
        if (!rotor?.animate) return;
        if (!spin || accelerate) {
          spin?.cancel();
          spin = rotor.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(360deg)' }], { duration: 20000, iterations: Infinity, easing: 'linear' });
        }
        if (!enabled) { spin.pause(); return; }
        spin.play();
        if (!accelerate) { spin.playbackRate = 1; return; }
        const start = performance.now();
        spin.playbackRate = .001;
        function accelerateFrame(now) {
          if (signal.aborted || !enabled) return;
          const progress = Math.min(1, (now - start) / 1600);
          spin.playbackRate = Math.max(.001, progress * progress * (3 - 2 * progress));
          if (progress < 1) ramp = requestAnimationFrame(accelerateFrame);
        }
        ramp = requestAnimationFrame(accelerateFrame);
      }
      function finishDrawing() {
        drawVersion++;
        drawing?.cancel(); drawing = null;
        root.dataset.dtSpiral = 'spinning';
        startSpin(true);
      }
      function drawSpiral() {
        drawVersion++;
        const version = drawVersion;
        drawing?.cancel(); drawing = null;
        spin?.cancel(); spin = null; cancelAnimationFrame(ramp);
        if (!enabled || !line?.animate) { root.dataset.dtSpiral = 'spinning'; startSpin(); return; }
        root.dataset.dtSpiral = 'drawing';
        drawing = line.animate([
          {strokeDasharray:'1000',strokeDashoffset:'1000'},
          {strokeDasharray:'1000',strokeDashoffset:'0'}
        ], {duration:3200,easing:'linear',fill:'both'});
        drawing.finished.then(() => {
          if (!signal.aborted && version === drawVersion) finishDrawing();
        }).catch(() => {});
      }
      function setEnabled(value) {
        enabled = value;
        labels();
        cancelAnimationFrame(ramp);
        if (drawing) { if (enabled) drawing.play(); else drawing.pause(); }
        else if (enabled) startSpin(); else spin?.pause();
        if (!enabled && enter) { clearTimeout(readyTimer); enter.disabled = false; }
      }
      function selectCard(index) {
        if (selected >= 0) return;
        selected = index;
        cards.forEach((card, i) => {
          const active = i === selected;
          card.classList.toggle('is-selected', active);
          card.classList.toggle('is-flipped', active);
          card.setAttribute('aria-pressed', String(active));
          card.querySelector('.dt-card-front')?.setAttribute('aria-hidden', String(!active));
          card.setAttribute('aria-label', active ? card.querySelector('.dt-card-message').textContent.trim() : cardNames[i]);
          card.disabled = true;
        });
        choice?.querySelector('.dt-oracle-cards').classList.toggle('has-selection', selected >= 0);
        if (action) action.hidden = selected < 0;
        const announcement = intro?.querySelector('.dt-oracle-announcement');
        if (announcement) announcement.textContent = selected < 0 ? '' : cards[selected].querySelector('.dt-card-message').textContent;
      }
      function resetCards() {
        selected = -1;
        cards.forEach((card, i) => {
          card.disabled = false;
          card.classList.remove('is-selected', 'is-flipped');
          card.setAttribute('aria-pressed', 'false');
          card.setAttribute('aria-label', cardNames[i]);
          card.querySelector('.dt-card-front')?.setAttribute('aria-hidden', 'true');
        });
        choice?.querySelector('.dt-oracle-cards').classList.remove('has-selection');
        if (action) action.hidden = true;
        const announcement = intro?.querySelector('.dt-oracle-announcement');
        if (announcement) announcement.textContent = '';
      }
      function stopReflection() {
        reflectionVersion++;
        reflectionTimers.forEach(timer => clearTimeout(timer)); reflectionTimers.clear();
        reflectionAnimations.forEach(animation => animation.cancel()); reflectionAnimations.clear();
      }
      function resetReflection() {
        stopReflection();
        thoughts.forEach(thought => thought.hidden = true);
        if(reflection){reflection.hidden=false;reflection.inert=false;}
        if (deck) { deck.hidden = true; deck.inert = true; }
      }
      function revealThought(index) {
        const thought = thoughts[index];
        if (!thought) return;
        thought.hidden = false;
        if (!reduced.matches && thought.animate) {
          const animation = thought.animate([{opacity:0},{opacity:1}], {duration:900,easing:'cubic-bezier(.2,.7,.2,1)'});
          reflectionAnimations.add(animation);
          animation.finished.catch(() => {}).then(() => reflectionAnimations.delete(animation));
        }
      }
      async function revealDeck() {
        if (!deck || closing || signal.aborted) return;
        const version=reflectionVersion;
        if(!reduced.matches && reflection?.animate){
          const collapse=reflection.animate([
            {opacity:1,transform:'translateY(0) scale(1)'},
            {opacity:0,transform:'translateY(24px) scale(.95)'}
          ],{duration:cardTransition,easing:'cubic-bezier(.4,0,.2,1)',fill:'both'});
          reflectionAnimations.add(collapse);
          await collapse.finished.catch(()=>{});
          reflectionAnimations.delete(collapse);collapse.cancel();
          if(version!==reflectionVersion||closing||signal.aborted)return;
        }
        if(reflection){reflection.hidden=true;reflection.inert=true;}
        deck.hidden = false; deck.inert = false;
        intro.scrollTop=0;
        root.dataset.dtScene = 'cards';
        const title=deck.querySelector('.dt-choice-title');
        if(title){intro.setAttribute('aria-labelledby',title.id);title.focus({preventScroll:true});}
      }
      function afterReflectionDelay(callback, delay) {
        const version = reflectionVersion;
        const timer = setTimeout(() => {
          reflectionTimers.delete(timer);
          if (version === reflectionVersion && !closing && !signal.aborted) callback();
        }, delay);
        reflectionTimers.add(timer);
      }
      function play() {
        if (!intro) return;
        exitAnimation?.cancel(); closing = false; clearTimeout(readyTimer);
        enabled = !reduced.matches; labels(); resetCards(); resetReflection();
        showChapter('letter');
        intro.hidden = false; choice.hidden = true;
        welcome.inert = false; welcome.removeAttribute('aria-hidden');
        root.dataset.dtScene = 'welcome';
        intro.setAttribute('aria-labelledby', intro.querySelector('.dt-intro-title').id);
        setLocked(true);
        intro.classList.remove('is-replaying');
        void intro.offsetWidth;
        intro.classList.add('is-replaying');
        drawSpiral();
        enter.disabled = enabled;
        if (enabled) readyTimer = setTimeout(() => { enter.disabled = false; }, 6450);
        intro.querySelector('.dt-intro-title')?.focus({ preventScroll: true });
      }
      function showReflection() {
        if (!intro || closing || root.dataset.dtScene !== 'welcome') return;
        clearTimeout(readyTimer);
        if (drawing) finishDrawing();
        welcome.inert = true; welcome.setAttribute('aria-hidden', 'true');
        choice.hidden = false;
        root.dataset.dtScene = 'reflection';
        intro.setAttribute('aria-labelledby', thoughts[0].querySelector('p').id);
        intro.scrollTop = 0;
        revealThought(0);
        thoughts[0].querySelector('p').focus({preventScroll:true});
        if (reduced.matches) { thoughts.forEach((_, index) => revealThought(index)); afterReflectionDelay(revealDeck,readingDelay); }
        else {
          afterReflectionDelay(() => revealThought(1), 1900);
          afterReflectionDelay(() => revealThought(2), 3800);
          afterReflectionDelay(() => revealThought(3), 5700);
          afterReflectionDelay(revealDeck, readingDelay);
        }
      }
      async function finish() {
        if (!intro || closing) return;
        closing = true; clearTimeout(readyTimer); stopReflection();
        if (drawing) finishDrawing();
        // The creator's chapter is the only content behind the fading card scene.
        showChapter('letter', { push: true });
        setLocked(false);setScrollOffset();
        const title = root.querySelector('.dtj-letter h1');
        root.querySelector('.dtj-letter')?.scrollIntoView({behavior:'instant',block:'start'});
        arrivalAnimation?.cancel();
        if(!reduced.matches){
          arrivalAnimation=root.querySelector('.dtj-letter')?.animate([{opacity:.35,transform:'translateY(10px)'},{opacity:1,transform:'none'}],{duration:1050,delay:120,easing:'cubic-bezier(.2,.7,.2,1)'});
        }
        if (!reduced.matches && intro.animate) {
          exitAnimation = intro.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 650, easing: 'ease', fill: 'both' });
          await exitAnimation.finished.catch(() => {});
        }
        if (signal.aborted || !closing) return;
        intro.hidden = true; root.dataset.dtScene = 'page'; setLocked(false);
        exitAnimation?.cancel(); closing = false;
        title?.setAttribute('tabindex', '-1'); title?.focus({ preventScroll: true });
      }
      enter?.addEventListener('click', showReflection, { signal });
      cards.forEach((card, index) => card.addEventListener('click', () => selectCard(index), { signal }));
      intro?.querySelector('.dt-journey-enter')?.addEventListener('click', finish, { signal });
      intro?.querySelector('[data-dt-skip]')?.addEventListener('click', finish, { signal });
      replay?.addEventListener('click', play, { signal });
      if (replay) replay.hidden = !intro;
      [toggle, introToggle].filter(Boolean).forEach(button => button.addEventListener('click', () => setEnabled(!enabled), { signal }));
      intro?.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); finish(); return; }
        if (event.key !== 'Tab') return;
        const focusable = [...intro.querySelectorAll('button,a[href]')].filter(el => !el.disabled && !el.closest('[hidden],[inert]') && el.getClientRects().length);
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (!first) return;
        if (event.shiftKey && (document.activeElement === first || !focusable.includes(document.activeElement))) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || !focusable.includes(document.activeElement))) { event.preventDefault(); first.focus(); }
      }, { signal });
      reduced.addEventListener('change', () => {
        setEnabled(!reduced.matches);
        if (reduced.matches && root.dataset.dtScene === 'reflection') { stopReflection(); thoughts.forEach((_, index) => revealThought(index)); afterReflectionDelay(revealDeck,readingDelay); }
      }, { signal });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) { spin?.pause(); drawing?.pause(); }
        else if (enabled) { if (drawing) drawing.play(); else spin?.play(); }
      }, { signal });
      root.querySelector('[data-dtj-variant]')?.addEventListener('change', event => {
        const option=event.target.selectedOptions[0];
        const buy=root.querySelector('[data-dtj-buy]');
        root.querySelectorAll('[data-dtj-price]').forEach(price=>price.textContent=option.dataset.price);
        if(buy){buy.disabled=option.dataset.available!=='true';buy.textContent=buy.disabled?'IŠPARDUOTA':'Į KREPŠELĮ';}
      },{signal});
      const gallery=root.querySelector('[data-dtj-gallery]');
      const galleryImage=gallery?.querySelector('[data-dtj-gallery-image]');
      const thumbs=[...(gallery?.querySelectorAll('[data-dtj-gallery-thumb]')||[])];
      let galleryVersion=0;
      thumbs.forEach((button,index)=>button.addEventListener('click',async()=>{
        if(button.getAttribute('aria-pressed')==='true')return;
        const version=++galleryVersion;
        gallery.setAttribute('aria-busy','true');
        try{
          const next=new Image();next.src=button.dataset.src;await next.decode();
          if(signal.aborted||version!==galleryVersion)return;
          galleryImage.src=button.dataset.src;galleryImage.alt=button.dataset.alt||'';
          if(button.dataset.width)galleryImage.width=Number(button.dataset.width);
          if(button.dataset.height)galleryImage.height=Number(button.dataset.height);
          thumbs.forEach(thumb=>thumb.setAttribute('aria-pressed',String(thumb===button)));
          gallery.querySelector('[data-dtj-gallery-status]').textContent='Nuotrauka '+(index+1)+' iš '+thumbs.length+'.';
        }catch(error){
          if(!signal.aborted&&version===galleryVersion)gallery.querySelector('[data-dtj-gallery-status]').textContent='Nuotraukos nepavyko įkelti. Pabandyk dar kartą.';
        }finally{if(!signal.aborted&&version===galleryVersion)gallery.removeAttribute('aria-busy');}
      },{signal}));
      const mobilePurchase=root.querySelector('[data-dtj-mobile-purchase]');
      const buy=root.querySelector('[data-dtj-buy]'),stickyBuy=root.querySelector('[data-dtj-sticky-buy]');
      const small=matchMedia('(max-width:749px)');
      let purchaseObserver,buttonObserver,sceneObserver,commerceVisible=false,buyPassed=false;
      function syncSticky(){
        if(!mobilePurchase)return;
        mobilePurchase.hidden=!(small.matches&&root.dataset.dtScene==='page'&&root.dataset.dtChapter==='product'&&commerceVisible&&buyPassed);
        if(stickyBuy&&buy){stickyBuy.disabled=buy.disabled||buy.getAttribute('aria-disabled')==='true'||buy.classList.contains('loading');stickyBuy.textContent=buy.disabled?'IŠPARDUOTA':'Į KREPŠELĮ';}
      }
      if(mobilePurchase&&buy&&'IntersectionObserver' in window){
        const commerce=root.querySelector('.dtj-commerce');
        purchaseObserver=new IntersectionObserver(entries=>{
          entries.forEach(entry=>{if(entry.target===commerce)commerceVisible=entry.isIntersecting;if(entry.target===buy)buyPassed=entry.boundingClientRect.bottom<=0;});
          syncSticky();
        });
        purchaseObserver.observe(commerce);purchaseObserver.observe(buy);
        buttonObserver=new MutationObserver(syncSticky);buttonObserver.observe(buy,{attributes:true,attributeFilter:['disabled','aria-disabled','class']});
        sceneObserver=new MutationObserver(syncSticky);sceneObserver.observe(root,{attributes:true,attributeFilter:['data-dt-scene','data-dt-chapter']});
        small.addEventListener('change',syncSticky,{signal});
        stickyBuy?.addEventListener('click',()=>{if(!stickyBuy.disabled)buy.click();},{signal});
      }
      // Upgrade ordinary anchor chapters into an accessible horizontal tab set.
      const about=root.querySelector('[data-dtj-about]');
      const aboutList=about?.querySelector('[data-dtj-about-tabs]');
      const aboutTabs=[...(about?.querySelectorAll('[data-dtj-about-tab]')||[])];
      const aboutPanels=[...(about?.querySelectorAll('[data-dtj-about-panel]')||[])];
      function selectAbout(index,{focus=false,scroll=false}={}) {
        if(index<0||index>=aboutTabs.length||!aboutPanels[index])return;
        aboutTabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
        aboutPanels.forEach((panel,i)=>{panel.hidden=i!==index;panel.inert=i!==index;});
        const tab=aboutTabs[index];
        if(focus)tab.focus({preventScroll:true});
        if(scroll)aboutList.scrollTo({left:aboutList.scrollLeft+tab.getBoundingClientRect().left-aboutList.getBoundingClientRect().left-(aboutList.clientWidth-tab.offsetWidth)/2,behavior:reduced.matches?'instant':'smooth'});
      }
      if(aboutTabs.length&&aboutTabs.length===aboutPanels.length) {
        about.dataset.dtjAboutReady='true';aboutList.setAttribute('role','tablist');aboutList.setAttribute('aria-orientation','horizontal');
        aboutTabs.forEach((tab,i)=>{
          tab.setAttribute('role','tab');tab.setAttribute('aria-controls',aboutPanels[i].id);aboutPanels[i].setAttribute('role','tabpanel');
          tab.addEventListener('click',event=>{event.preventDefault();selectAbout(i,{scroll:true});},{signal});
          tab.addEventListener('keydown',event=>{
            let next=i;
            if(event.key==='ArrowRight')next=(i+1)%aboutTabs.length;
            else if(event.key==='ArrowLeft')next=(i+aboutTabs.length-1)%aboutTabs.length;
            else if(event.key==='Home')next=0;
            else if(event.key==='End')next=aboutTabs.length-1;
            else if(event.key!==' ')return;
            event.preventDefault();selectAbout(next,{focus:true,scroll:true});
          },{signal});
        });
        const linked=aboutPanels.findIndex(panel=>panel.id===location.hash.slice(1));selectAbout(linked<0?0:linked,{scroll:linked>=0});
      }

      // Links remain ordinary section anchors without JavaScript; enhanced visits show one chapter.
      root.querySelectorAll('a[href^="#"]:not([data-dtj-about-tab])').forEach(link=>link.addEventListener('click',event=>{
        const target=document.getElementById(link.hash.slice(1));
        if(!target||!root.contains(target))return;
        event.preventDefault();
        showChapter(chapterFor(target), {target,focus:true,scroll:true,push:true,animate:true});
      },{signal}));
      function restoreLocation() {
        const target=document.getElementById(location.hash.slice(1));
        const valid=target&&root.contains(target)&&!target.closest('.dt-intro');
        const linkedPanel=target?.closest('[data-dtj-about-panel]');if(linkedPanel)selectAbout(aboutPanels.indexOf(linkedPanel));
        if (!valid && intro) { play(); return; }
        exitAnimation?.cancel(); closing=false; clearTimeout(readyTimer); stopReflection();
        if(intro)intro.hidden=true;
        setLocked(false);root.dataset.dtScene='page';startSpin();
        showChapter(valid?chapterFor(target):'product',{target:valid?target:null,scroll:true,focus:true});
      }
      window.addEventListener('popstate', restoreLocation, {signal});
      labels();
      const deepTarget=document.getElementById(location.hash.slice(1));
      if(intro && !(deepTarget && root.contains(deepTarget) && !deepTarget.closest('.dt-intro'))) play();
      else {
        root.dataset.dtScene='page';startSpin();
        showChapter(deepTarget?chapterFor(deepTarget):'product');
        if(deepTarget)requestAnimationFrame(()=>deepTarget.scrollIntoView({behavior:'instant',block:'start'}));
      }

      instances.set(root, () => {
        controller.abort(); cancelAnimationFrame(ramp); clearTimeout(readyTimer); stopReflection();
        drawVersion++; drawing?.cancel(); spin?.cancel(); exitAnimation?.cancel(); arrivalAnimation?.cancel();
        purchaseObserver?.disconnect();buttonObserver?.disconnect();sceneObserver?.disconnect();headerObserver?.disconnect();galleryVersion++;setLocked(false);
        document.body.classList.remove('dt-reading-active');root.classList.remove('dtj-staged');delete root.dataset.dtChapter;
        if(about)delete about.dataset.dtjAboutReady;
        aboutList?.removeAttribute('role');aboutList?.removeAttribute('aria-orientation');
        aboutTabs.forEach(tab=>{tab.removeAttribute('role');tab.removeAttribute('aria-controls');tab.removeAttribute('aria-selected');tab.removeAttribute('tabindex');});
        aboutPanels.forEach(panel=>{panel.hidden=false;panel.inert=false;panel.removeAttribute('role');});
        originalVisibility.forEach((state,element)=>{
          element.hidden=state.hidden;element.inert=state.inert;
          if(state.display)element.style.setProperty('display',state.display,state.priority);else element.style.removeProperty('display');
        });originalVisibility.clear();
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('.dt').forEach(root => { instances.get(root)?.(); instances.delete(root); }));
})();
